<template>
    <div v-if="isActive" class="pageLoader">
        <loading-progress
                indeterminate
                hide-background
                size="64"
                rotate
                fillDuration="2"
                rotationDuration="1"
        />
    </div>
</template>

<script>
    import Vue from "vue"
    import 'vue-progress-path/dist/vue-progress-path.css'
    import VueProgress from 'vue-progress-path'

    Vue.use(VueProgress);

    export default {
        name: "Loader",
        data () {
          return {
              isActive: false,
              mounted: false,
          }
        },

        mounted: function () {
            this.mounted = true;
            document.getElementById('app').appendChild(this.$el);
        },

        methods: {
            show: function () {
                if (!this.mounted) {
                    this.$mount()
                }
                this.isActive = true;
            },

            hide: function () {
                this.isActive = false;
            }

        }
    }
</script>

<style lang="scss">
    .pageLoader {
        position: fixed;
        height: 100%;
        width: 50%;
        top: 0;
        right: 0;
        background-color: rgba(255,255,255,0.5);
    }
    .vue-progress-path {
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -57px 0 0 -57px;
        path {
            stroke-width: 4;
        }
        .progress {
            stroke: #f44336;
        }
    }


    @media (max-width: 600px) {
        .pageLoader {width: 100%;}
    }
</style>